import Vue from 'vue'
import browserDetect from 'vue-browser-detect-plugin'

export default Vue.use(browserDetect)
